import { withZod } from '@remix-validated-form/with-zod'
import { z } from 'zod'
import { zfd } from 'zod-form-data'

const notificationItemSchema = z
  .object({
    email: zfd.checkbox(),
    app: zfd.checkbox(),
  })
  .optional()

export const editSchema = z.object({
  phoneCalls: z
    .object({
      canceledAppointment: notificationItemSchema,
      allUnscheduledCalls: notificationItemSchema,
      newPatientUnscheduledCalls: notificationItemSchema,
      callbackRequested: notificationItemSchema,
      missedCalls: notificationItemSchema,
      voicemail: notificationItemSchema,
      enabled: zfd.checkbox(),
    })
    .optional(),
  textMessages: z
    .object({
      newTextMessage: notificationItemSchema,
      enabled: zfd.checkbox(),
    })
    .optional(),
  formSubmissions: z
    .object({
      newFormSubmission: notificationItemSchema,
      enabled: zfd.checkbox(),
    })
    .optional(),
  scheduler: z
    .object({
      newAppointmentBooked: notificationItemSchema,
      enabled: zfd.checkbox(),
    })
    .optional(),
  aiAgent: z
    .object({
      newAIAgentCall: notificationItemSchema,
      emergencyAppointmentRequest: notificationItemSchema,
      newAppointmentBooked: notificationItemSchema,
      enabled: zfd.checkbox(),
    })
    .optional(),
  pmsData: z
    .object({
      noPatientLinkedOnScheduledContact: notificationItemSchema,
      noAppointmentFoundOnScheduledContact: notificationItemSchema,
      brokenAppointment: notificationItemSchema,
      enabled: zfd.checkbox(),
    })
    .optional(),
})

export const editValidator = withZod(editSchema)
